import { render, staticRenderFns } from "./OrganizationSettings.vue?vue&type=template&id=6b7eda7e&scoped=true"
import script from "./OrganizationSettings.vue?vue&type=script&lang=js"
export * from "./OrganizationSettings.vue?vue&type=script&lang=js"
import style0 from "./OrganizationSettings.vue?vue&type=style&index=0&id=6b7eda7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7eda7e",
  null
  
)

export default component.exports